import React from 'react';
import radium from 'radium';
import Button from "../../components/button/Button";
import {ThemeContext} from "../../components/theme/Theme.jsx";

interface CheckoutButtonsProps {
	btnBackLabel?: string,
	btnBackStyle?: any,
	btnNextLabel?: string,
	btnNextStyle?: any,
	btnResetLabel?: string,
	btnResetStyle?: any,
	hideResetButton?: boolean,
	hideNextButton?: boolean,
	hideBackButton?: boolean,
	disableResetButton?: boolean,
	disableNextButton?: boolean,
	disableBackButton?: boolean,
	onResetClick?: any,
	onNextClick?: any,
	onBackClick?: any
}


const defaultProps = {
	btnBackLabel: '',
	btnNextLabel: '',
	btnResetLabel: '',
	hideResetButton: false,
	hideNextButton: false,
	hideBackButton: false,
	disableResetButton: false,
	disableNextButton: false,
	disableBackButton: false,
};

function CheckoutButtons(propsIn: CheckoutButtonsProps) {
	const props = {...defaultProps, ...propsIn};
	const context = React.useContext(ThemeContext);
	const style: any = {
		container: {
			margin: 'auto',
			display: 'flex',
			flexWrap: 'wrap',
			alignContent: 'center',
			paddingBottom: '5em',
		},
		buttonContainerNext: {
			marginTop: '3em',
			order: 1,
			'@media(min-width : 768px)': {
				order: 2
			}
		},
		buttonContainerBack: {
			marginTop: '3em',
			order: 2,
			'@media(min-width : 768px)': {
				order: 1
			}
		},
		buttonContainerReset: {
			marginTop: '3em',
			order: 3,
		}
	}
	
	return (
		<div style={style.container}>
			{!props.hideBackButton &&
			<Button
				name="back"
				buttonText={props.btnBackLabel || context.themeManager.getThemeTextOrHardcodedDefault('checkoutBtnBackLabel')}
				btnStyle={props.btnBackStyle || 'highlight' }
				onClick={()=>props.onBackClick()}
				buttonContainerStyle={style.buttonContainerBack}
				disabled={props.disableBackButton}
			/>}
			{!props.hideNextButton &&
			<Button
				name="next"
				buttonText={props.btnNextLabel || context.themeManager.getThemeTextOrHardcodedDefault('checkoutBtnNextLabel')}
				btnStyle={props.btnNextStyle || 'highlight' }
				onClick={() =>props.onNextClick()}
				buttonContainerStyle={style.buttonContainerNext}
				disabled={props.disableNextButton}
			/>}
			{!props.hideResetButton &&
			<Button
				name="reset"
				buttonText={props.btnResetLabel || context.themeManager.getThemeTextOrHardcodedDefault('checkoutBtnResetLabel')}
				btnStyle={props.btnResetStyle || '' }
				onClick={() => props.onResetClick()}
				buttonContainerStyle={style.buttonContainerReset}
				disabled={props.disableResetButton}
			/>}
		</div>
	);
}

export default radium(CheckoutButtons);
